/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Settings_Reasoning_Desc_LowInputs */



/**
* | output |
* | --- |
* | "Brief internal reasoning. Good for quick tasks." |
*
* @param {Model_Settings_Reasoning_Desc_LowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_settings_reasoning_desc_low = /** @type {((inputs?: Model_Settings_Reasoning_Desc_LowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Settings_Reasoning_Desc_LowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kurz gefasste interne Begründung. Gut für schnelle Aufgaben.")
	return /** @type {LocalizedString} */ ("Brief internal reasoning. Good for quick tasks.")
});